import { z } from 'zod';

export const CategorySchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  labelRo: z.string(),
  labelRu: z.string(),
  labelEn: z.string(),
  isCustom: z.boolean(),
  isActive: z.boolean(),
  createdBy: z.string().uuid().nullable(),
  createdAt: z.string(),
});
export type Category = z.infer<typeof CategorySchema>;

export const CreateCategoryInputSchema = z
  .object({
    code: z
      .string()
      .min(2)
      .max(64)
      .regex(/^[a-z0-9_]+$/, 'code must be lowercase letters, digits, underscore')
      .optional(),
    labelRo: z.string().min(1).max(100),
    labelRu: z.string().min(1).max(100),
    labelEn: z.string().min(1).max(100),
    isCustom: z.boolean().optional(),
  })
  .strict();
export type CreateCategoryInput = z.infer<typeof CreateCategoryInputSchema>;

export const UpdateCategoryInputSchema = z
  .object({
    labelRo: z.string().min(1).max(100).optional(),
    labelRu: z.string().min(1).max(100).optional(),
    labelEn: z.string().min(1).max(100).optional(),
    isActive: z.boolean().optional(),
    isCustom: z.boolean().optional(),
  })
  .strict();
export type UpdateCategoryInput = z.infer<typeof UpdateCategoryInputSchema>;

export const ListCategoriesQuerySchema = z.object({
  includeInactive: z.coerce.boolean().optional(),
  includeCustom: z.coerce.boolean().default(true),
});
export type ListCategoriesQuery = z.infer<typeof ListCategoriesQuerySchema>;
